import React, { Component } from 'react';
import i18n from 'react-intl-universal';
import classNames from 'classnames';
import { noop, stopEvent, formatNumByK } from '@/utils/util';
import styles from './QrcodeModal.scss';

const defaultW = 200;
const defaultH = 200;
export default class QrcodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { link } = this.props;
    this.setTheQrcodeData({ link });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible !== this.props.visible) {
      this.setTheQrcodeData({ link: nextProps.link });
    }
  }

  setTheQrcodeData = ({ link = '', w, h }) => {
    if (window.QRCode) {
      if (this.bigQrcode) {
        this.bigQrcode.clear();
        this.bigQrcode.makeCode(link);
        return;
      }
      this.bigQrcode = new QRCode(document.getElementById('big-qrcode'), {
        text: link,
        width: w || defaultW,
        height: h || defaultH,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
    }
  }
  onQrcodeModalBodyClick = (e) => {
    stopEvent(e);
  }
  onQrcodeModalCancelClick = (e) => {
    const { onModalCancel } = this.props;
    onModalCancel(e);
  }

  render() {
    const { visible } = this.props;
    const modalClass = classNames(styles['qrcode-modal'], {
      [styles['hidden']]: !visible,
    });
    return (
      <div
        className={modalClass}
        onClick={this.onQrcodeModalCancelClick}
      >
        <div
          className={styles['qr-modal-body']}
          onClick={this.onQrcodeModalBodyClick}
        >
          <span
            className={styles['close-btn']}
            onClick={this.onQrcodeModalCancelClick}
          >
            ×
          </span>
          <div className={styles['qr-modal--title']}>
            {i18n.get('share.wechat-des')}
          </div>
          <div id="big-qrcode"/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/QrcodeModal/QrcodeModal.js